// Header overflow popover — the ☰ hamburger on mobile. Expands a
// floating panel containing mode/difficulty dropdowns and theme. On
// desktop the same container flows inline (CSS handles that); the ☰
// button is hidden via the .menu-btn display rule.
//
// Dropdowns register their own close callback via `registerNestedClose`
// so reopening the menu starts clean.

import { byId } from "./dom";

const nestedCloseHandlers: Array<() => void> = [];

/** Register a callback that runs when the header menu closes.
 *  Used by dropdown modules to collapse themselves on menu close. */
export function registerNestedClose(fn: () => void): void {
  nestedCloseHandlers.push(fn);
}

export function openHeaderMenu(): void {
  byId("headerOverflow")?.classList.add("open");
  byId("menuBtn")?.setAttribute("aria-expanded", "true");
}

export function closeHeaderMenu(): void {
  byId("headerOverflow")?.classList.remove("open");
  byId("menuBtn")?.setAttribute("aria-expanded", "false");
  // Collapse any nested dropdowns so reopening starts clean.
  for (const fn of nestedCloseHandlers) fn();
}

/** Wire toggle + outside-click. Call once. */
export function installHeaderMenu(): void {
  const menuBtn = byId("menuBtn");
  const headerOverflow = byId("headerOverflow");
  menuBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    if (headerOverflow?.classList.contains("open")) closeHeaderMenu();
    else openHeaderMenu();
  });
  document.addEventListener("click", (e) => {
    // Outside-click closes the menu, but taps inside the popover or on
    // the toggle itself should be ignored.
    if (
      headerOverflow?.classList.contains("open") &&
      !headerOverflow.contains(e.target as Node) &&
      e.target !== menuBtn
    ) {
      closeHeaderMenu();
    }
  });
}
